/**
 * In-memory scroll positions of open SeparateContentLayout sheets, keyed by the layout's `internalId`.
 * Module-level on purpose: it survives navigation inside the SPA and is reset by a full page reload.
 * An entry exists only while its sheet is open, so its presence means "restore the sheet open".
 */
const scrollPositions = new Map<string, number>();

export const getScrollKey = (internalId: string) => `separate_layout_scroll_${internalId}`;

export const saveScrollPosition = (key: string, scrollTop: number): void => {
    scrollPositions.set(key, scrollTop);
};

export const getScrollPosition = (key: string): number | undefined => scrollPositions.get(key);

export const clearScrollPosition = (key: string): void => {
    scrollPositions.delete(key);
};

/** Drops every saved position. Meant for logout once `@libs/core` exposes a logout hook (core-change-request). */
export const clearAllScrollPositions = (): void => {
    scrollPositions.clear();
};
